import React from "react";
import { cn } from "@/utils/helpers";
import SvgIcon, { SvgIconProps } from "./SvgIcon";
import styles from "../Svg.module.css";

export default function SvgIconZoomFit({
	className,
	...props
} : SvgIconProps) {
	return (
		<SvgIcon
			className={cn(styles.SvgIconZoomFit, className)}
			{...props}
		>
			<path
				d="M40.6055 0.261778C41.223 -0.14548 42.06 -0.077624 42.6035 0.46588C43.147 1.00936 43.2157 1.84635 42.8086 2.46393L42.6074 2.7149L33.9365 11.3858H50L52.5771 11.4522C78.9939 12.7924 99.9987 34.636 100 61.3858C100 89.0004 77.6144 111.391 50 111.391C22.3865 111.39 0 88.9998 0 61.3858C0.00132773 60.5082 0.714875 59.7981 1.59277 59.7979C2.47081 59.7979 3.18422 60.5081 3.18555 61.3858C3.18555 87.2421 24.1443 108.204 50 108.205C75.8566 108.205 96.8193 87.2428 96.8193 61.3858C96.818 36.3377 77.1468 15.8863 52.4102 14.6329L50 14.5713L49.9951 14.5704V14.5713H33.8799L42.6074 23.2989C43.2273 23.9205 43.2244 24.927 42.6035 25.5479C41.9825 26.1687 40.976 26.171 40.3545 25.5508L27.8105 13.0069L40.3545 0.461974L40.6055 0.261778Z"
			/>
		</SvgIcon>
	)
}
